import React from 'react';
import SpecificContactContent from '../../../components/marketing/pageSections/specificContact/SpecificContactContent';

function Home(props) {
    return (
        <>
            <SpecificContactContent />
        </>
    );
}

export default Home;